var __jsx = React.createElement;
import React, { useContext, useEffect, useState } from "react";
import Alert from ".";
import { getIsOnpremise, getIsPatientDeletionEnabled } from "../../utils";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { get, isEmpty } from "lodash";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { PatientsContext } from "../Patients/PatientsContext";
import { LicenseContext } from "../LicenseManager/LicenseContext";
import { useTranslation } from "react-i18next";
import { useAuth } from "@qure/qure-auth";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
function Warning() {
  var _useContext = useContext(PatientsContext),
    wsData = _useContext.wsData;
  var _useState = useState(0),
    trialLicenseRemaining = _useState[0],
    setTrialLicenseRemaining = _useState[1];
  var _useContext2 = useContext(LicenseContext),
    stickyAlert = _useContext2.stickyAlert,
    alertDetails = _useContext2.alertDetails;
  var isOnpremise = getIsOnpremise();
  var isPatientDeletionEnabled = getIsPatientDeletionEnabled();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isLoggedin = get(userInfo, ["authenticated"], false);
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        isDiskSpaceWarning: store.isDiskSpaceWarning,
        patientsFileDeletionStatus: store.patientsFileDeletionStatus
      };
    }),
    isDiskSpaceWarning = _useStoreState.isDiskSpaceWarning,
    patientsFileDeletionStatus = _useStoreState.patientsFileDeletionStatus;
  useEffect(function () {
    if (userInfo) {
      setTrialLicenseRemaining(userInfo.trial_scans_remaining || 0);
    }
  }, [userInfo]);
  useEffect(function () {
    if (wsData && (wsData === null || wsData === void 0 ? void 0 : wsData.action) == "license_activation") {
      var _wsData$content;
      setTrialLicenseRemaining((wsData === null || wsData === void 0 || (_wsData$content = wsData.content) === null || _wsData$content === void 0 ? void 0 : _wsData$content.trial_scans_remaining) || 0);
    }
  }, [wsData]);
  var diskUsage = get(userInfo, ["disk_usage"], {});
  var isDeletionStatus = function isDeletionStatus(status) {
    return ["in_process", "started"].includes(status);
  };
  var isFilesDeletionOn = isDeletionStatus(diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.file_deletion) || isDeletionStatus(patientsFileDeletionStatus);
  var onClickDiskAlert = function onClickDiskAlert(type) {
    // add code to track event on mixpanel, add event name as DISK_SPACE_ALERT_CLICKED and type in properties
    trackEvent(MIXPANEL_EVENTS.DISK_SPACE_ALERT_CLICKED, {
      type: type
    });
    Store.update(function (s) {
      s.isSettingsOpen = true;
      s.selectedSetting = "disk-management";
    });
  };
  var onClickLicenseAlert = function onClickLicenseAlert(type) {
    trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_CLICKED, {
      type: type
    });
    Store.update(function (s) {
      s.isSettingsOpen = true;
      s.selectedSetting = "license";
    });
  };
  var diskAlertContent = function diskAlertContent() {
    if (!isOnpremise || !isPatientDeletionEnabled) return null;
    if (isFilesDeletionOn && patientsFileDeletionStatus !== "completed") {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-800",
        messageKey: "disk_management.deletion_message",
        showProgress: true
      });
    }
    if ((diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 99) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-600",
        icon: faTriangleExclamation,
        messageKey: "disk_management.popup_message_critical",
        onClick: function onClick() {
          return onClickDiskAlert("critical");
        }
      });
    }
    if (isDiskSpaceWarning) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-yellow-400 text-gray-900",
        icon: faTriangleExclamation,
        onClick: function onClick() {
          return onClickDiskAlert("warning");
        },
        messageKey: "disk_management.popup_message_warning",
        dynamicMessagePart: {
          usedPercent: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent,
          totalDisk: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.total
        }
      });
    }
    return null;
  };
  var licenseExpiredContent = function licenseExpiredContent() {
    if (isLoggedin && !isEmpty(alertDetails) && alertDetails !== null && alertDetails !== void 0 && alertDetails.isExpired) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-600 cursor-pointer",
        icon: faTriangleExclamation,
        messageKey: "license_expire.popup_message",
        onClick: function onClick() {
          return onClickLicenseAlert("expired");
        }
      });
    }
  };
  var licenseGracePeriodContent = function licenseGracePeriodContent() {
    if (isLoggedin && !isEmpty(alertDetails) && alertDetails !== null && alertDetails !== void 0 && alertDetails.in_grace_period) {
      return /*#__PURE__*/React.createElement(Alert, {
        className: "bg-red-700 text-gray-100 cursor-pointer",
        icon: faTriangleExclamation,
        messageKey: t("license_manager.license_grace_period_message", {
          remaining: alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.grace_days_remaining
        }),
        onClick: function onClick() {
          return onClickLicenseAlert("grace_period");
        }
      });
    }
  };
  var licenseAlertContent = function licenseAlertContent() {
    if (!isLoggedin || isEmpty(stickyAlert)) return null;
    var _ref = stickyAlert || {},
      total_days_remaining = _ref.total_days_remaining,
      total_scans_remaining = _ref.total_scans_remaining,
      type = _ref.type;
    var remaining = type === "days" ? "".concat(total_days_remaining) : "".concat(total_scans_remaining);
    var message = t("license_manager.license_expire_after", {
      remaining: remaining
    });
    if (type === "days") {
      message = t("license_manager.license_expire_in", {
        remaining: remaining
      });
    }
    return /*#__PURE__*/React.createElement(Alert, {
      className: "bg-yellow-400 text-gray-800 cursor-pointer",
      icon: faTriangleExclamation,
      messageKey: message,
      onClick: function onClick() {
        return onClickLicenseAlert("regular");
      }
    });
  };
  var trialLicenseAlertContent = function trialLicenseAlertContent() {
    var isTrialActive = !!trialLicenseRemaining && trialLicenseRemaining > 0;
    if (!isTrialActive || !isLoggedin) {
      return null;
    }
    var message = t("license_manager.trial_license_remaining").replace("[1]", "".concat(trialLicenseRemaining));
    return /*#__PURE__*/React.createElement(Alert, {
      className: "bg-yellow-800 cursor-pointer",
      messageKey: message,
      onClick: function onClick() {
        return onClickLicenseAlert("trial");
      }
    });
  };
  return diskAlertContent() || licenseExpiredContent() || licenseGracePeriodContent() || licenseAlertContent() || trialLicenseAlertContent();
}
export default Warning;